import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { SubscriptionLike, take } from 'rxjs';

import { NotificationService, PillsService, SessionStorageService, UserService } from '@shared/services';
import { PillModel, SidebarRouteExtended, TogglerModel } from '@shared/models';
import { User } from '@shared/factories';

@Component({
  selector:    'pills-button',
  templateUrl: 'pills-button.component.html',
  host: { class: 'am-flex-align gap-s' },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class PillsButtonComponent implements OnInit, OnDestroy {
  subscriptions: SubscriptionLike[] = [];
  user:          User;
  pills:         PillModel[];
  activePills:   PillModel[];

  @Input() skipInitLoad: boolean;
  @Input() loading:      boolean;
  @Output() callback = new EventEmitter<boolean>();
  constructor(
    private notificationService:   NotificationService,
    private pillsService:          PillsService,
    private userService:           UserService,
    private sessionStorageService: SessionStorageService
  ) { }

  ngOnInit(): void {
    this.preparePills();
    this.subscriptions.push(this.pillsService.reload.subscribe(_ => {
      if (this.skipInitLoad) this.skipInitLoad = null;
      else                   this.callback.emit(true);
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
    this.subscriptions = [];
  }

  private preparePills(): void {
    this.user = this.userService.currentUserValue;
    this.sessionStorageService.activeTab.pipe(take(1)).subscribe(tab => this.loadTogglers(tab));
  }

  private loadTogglers(activeTab: SidebarRouteExtended): void {
    this.subscriptions.push(this.sessionStorageService.headerTogglers.subscribe(toggler => {
      let activeToggler: TogglerModel;
      if      (activeTab.identifier === 'archive')    activeToggler = toggler.archive.find(f => f.active);
      else if (activeTab.identifier === 'failed-erp') activeToggler = toggler.failed_erp.find(f => f.active);

      if (!this.pills) this.loadPills();
      else this.mapBetaLocations(activeTab, activeToggler);
    }));
  }

  private loadPills(): void {
      this.subscriptions.push(this.sessionStorageService.pills.subscribe(pills => {
      this.pills       = pills;
      this.activePills = pills.filter(p => p.active);
    }));
  }

  private mapBetaLocations(activeTab: SidebarRouteExtended, activeToggler: TogglerModel): void {
    let betaFlag    = activeToggler?.beta || activeTab.betaFlag;
    let betaFeature = this.userService.currentUserValue?.features && this.userService.currentUserValue.features[betaFlag];

    let betaFullyEnabled = betaFeature && this.userService.currentUserValue.features[betaFlag] === true;
    let betaLocations    = betaFeature && this.userService.currentUserValue.features[betaFlag] || [];

    if (betaFlag && !betaFullyEnabled) this.pills.forEach(e => { e.disabled = !betaLocations.find(l => +e.location === +l); });
    else this.pills.forEach(e => { e.disabled = false });
    this.pillsService.persistPills(this.pills, true);
  }

  openPopup(): void {
    this.pillsService.openPicker();
  }

}
